import { GridRowId } from "@mui/x-data-grid-premium";
import { createSlice } from "@reduxjs/toolkit";
import VwHbsArsivdepoDTO from "src/models/PatolojiModul/VwHbsArsivdepoDTO";
import VwHbsArsivtanimDTO from "src/models/PatolojiModul/VwHbsArsivtanimDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";

interface IPatolojiArsivleme {
    searchHandler?: boolean;
    open: boolean;
    iptalOpen: boolean;
    activeRow: VwHbsArsivdepoDTO;

    expandedRows: Record<GridRowId, boolean>;
    depoActiveRow: VwHbsArsivtanimDTO;

    dolapUstId: number;
    dolapSira: number;
    dolapActiveRow: VwHbsArsivtanimDTO;
    dolapOpen: boolean;
};

export const PatolojiArsivlemeSlice = createSlice<IPatolojiArsivleme, MapReducerPayloads<IPatolojiArsivleme, {
    setSearchHandler?: boolean;
    setOpen: boolean;
    setIptalOpen: boolean;
    setActiveRow: VwHbsArsivdepoDTO;

    setExpandedRows: Record<GridRowId, boolean>;
    setDepoActiveRow: VwHbsArsivtanimDTO;

    setDolapUstId: number;
    setDolapSira: number;
    setDolapActiveRow: VwHbsArsivtanimDTO;
    setDolapOpen: boolean;
}>>({
    name: "patolojiArsivleme",
    initialState: {
        searchHandler: true,
        open: false,
        iptalOpen: false,
        activeRow: new VwHbsArsivdepoDTO(),

        expandedRows: {},
        depoActiveRow: new VwHbsArsivtanimDTO(),

        dolapUstId: 0,
        dolapSira: 0,
        dolapActiveRow: new VwHbsArsivtanimDTO(),
        dolapOpen: false,
    },
    reducers: {
        //Arama kriterlerini doldurduktan sonra api ye gidip veriyi çektiği state
        setSearchHandler: (state, action) => {
            state.searchHandler = action.payload
        },
        setOpen: (state, action) => {
            state.open = action.payload
        },
        setIptalOpen: (state, action) => {
            state.iptalOpen = action.payload
        },
        setActiveRow: (state, action) => {
            state.activeRow = action.payload
        },

        setExpandedRows: (state, action) => {
            state.expandedRows = action.payload
        },
        setDepoActiveRow: (state, action) => {
            state.depoActiveRow = action.payload
        },

        setDolapUstId: (state, action) => {
            state.dolapUstId = action.payload
        },
        setDolapSira: (state, action) => {
            state.dolapSira = action.payload
        },
        setDolapActiveRow: (state, action) => {
            state.dolapActiveRow = action.payload
        },
        setDolapOpen: (state, action) => {
            state.dolapOpen = action.payload
        }
    }
});